const STORAGE_KEY = 'sso_remembered_email'

export function useRememberEmail() {
  const rememberedEmail = ref('')
  const rememberMe = ref(false)

  // Charger depuis localStorage au montage
  if (import.meta.client) {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      rememberedEmail.value = stored
      rememberMe.value = true
    }
  }

  function saveEmail(email: string) {
    if (rememberMe.value && email) {
      localStorage.setItem(STORAGE_KEY, email)
    }
    else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  return {
    rememberedEmail,
    rememberMe,
    saveEmail,
  }
}
